<template>
  <validator name="validator">
    <form novalidate>
      <div class="card card-content">
        <div class="card-header">
          <div class="header">
            <div class="breadcrumb">
              <a class="breadcrumb-item" v-link="{ path: '/'}">Accueil</a>
              <a class="breadcrumb-item" v-link="{ path: '/project/list'}">Gestion des parcours</a>
              <a class="breadcrumb-item" v-link="{ name: 'editContact', params: { contactId: this.project.contact_id } }">{{ contact.leader_firstname }} {{ contact.leader_lastname }}</a>
              <a class="breadcrumb-item" v-link="{ name: 'editProject', params: { projectId: project.id } }">Informations</a>
            </div>
            <h1>Parcours de {{ contact.leader_firstname }} {{ contact.leader_lastname }}</h1>
          </div>
          <div class="actions">
           	<a class="btn btn-link" v-link="{ name: 'addMeetingWithProject', params: { contactId: project.contact_id, projectId: project.id } }">Ajouter un rdv</a>
            <button class="btn btn-link" v-on:click.prevent="saveProject" :class="{ disabled: !$validator.valid }">Sauvegarder le parcours</button>
          </div>
        </div>
        <div class="card-block">
          <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link active" v-link="{ name: 'editProject', params: { projectId: project.id }}">Informations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'planningProject', params: { projectId: project.id }}">Planning</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editProject.sortie', params: { projectId: project.id }}">Fiche de sortie</a>
        </li>
          </ul>
        </div>
        <div class="card-block">
          <fieldset>
            <legend>Informations générales</legend>
                <div class="form-group">
                    <label for="name">Parcours *</label>
                    <!-- v-validate:name = "validationRules.name" -->
                    <select
                      id      = "project_type_id"
                      v-model = "project.project_type_id"
                      class   = "form-control"
                      v-validate:project_type_id = "validationRules.project_type_id"
                      @change = "showForm()"
                    >
                    <option v-for="projectType in projectTypes" v-bind:value="projectType.id">{{ projectType.name }}</option>
                    </select>
                    <!-- :selected = "intituleParcours.id == currentProject.project_type_id" -->
                    <small class="form-text text-danger" v-if="$validator.project_type_id.required">Vous devez choisir un parcours</small>
                </div>
                        <div class="form-group">
                            <label for="name">Statut *</label>
                            <select
                              id      = "project_status_id"
                              name    = "project_status_id"
                              v-model = "project.project_status_id"
                              class   = "form-control"
                              v-validate:status = "validationRules.status"
                            >
                                <option value=""></option>
                                <option value="1">Ouvert</option>
                                <option value="2">Fermé</option>
                                <option value="3">En attente</option>
                                <option v-for="intituleStatut in projectStatus" :value="intituleStatut.value">{{ intituleStatut.label }}</option>
                            </select>
                          <!--<small class="form-text text-danger" v-if="$validator.status.required">Vous devez choisir un statut</small>-->
                        </div>
		        <legend>Contact</legend>
		        <!-- Contact -->
	        <div class="form-group">
                  <!--
	          <label for="contact">Participant</label>
	          <select
	            id      = "contact"
                    class   = "form-control"
                    v-model = "project.contact_id"
                    v-validate:participant = "validationRules.participant"
	          >
	          <option
	            v-for="contact_tmp of contacts"
	            v-bind:value="contact_tmp.id"
	            :class="{ 'me': contact_tmp.id == project.contact_id }"
	          >
	            {{ contact_tmp.leader_lastname }} {{ contact_tmp.leader_firstname }}
	          </option>
                  </select
                  -->
                  <input type="hidden" id="contact" class="form-control" value="{{ project.contact_id }}" />
               <!--<small class="form-text text-danger" v-if="$validator.participant.required">Vous devez choisir un participant</small>-->
	        </div>
                <div class="row">
                    <div class="col-sm-6">
                        <!-- Date contact -->
                        <div class="form-group">
                            <label for="contact_date_fl">Date prise de contact / réception FL</label>
                            <!--
                            <date-picker
                                    :time.sync = "project.contact_date_fl"
                                    :option    = "datepickerOptions"
                                    :inputClass = "form-control"
                            ></date-picker>
                            -->
                            <input
                                      id               = "contact_date_fl"
                                      class            = "form-control"
                                      type             = "text"
                                      v-model          = "project.contact_date_fl"
                                    >
                            <!--<small class="form-text text-danger" v-if="$validator.contact_date_fl.required">Vous devez indiquer une date</small>-->
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <!-- Date entree -->
                        <div class="form-group">
                            <label for="first_meeting_date">Date entrée / 1er rdv effectif</label>
                            <!--
                            <date-picker
                                    :time.sync = "project.first_meeting_date"
                                    :option    = "datepickerOptions"
                                    :inputClass = "form-control"
                            ></date-picker>
                            -->
                            <input
                                      id               = "first_meeting_date"
                                      class            = "form-control"
                                      type             = "text"
                                      v-model          = "project.first_meeting_date"
                                    >
                            <!--<small class="form-text text-danger" v-if="$validator.first_meeting_date.required">Vous devez indiquer une date</small>-->
                        </div>
                    </div>
                            <div class="col-sm-6">
                                <!-- Date reunion info -->
                                <div class="form-group">
                                    <label for="meeting_date_incubator_info">Date réunion info</label>
                                    <!--
                                    <date-picker
                                        :time.sync = "project.meeting_date_incubator_info"
                                        :option    = "datepickerOptions"
                                        :inputClass = "form-control"
                                    ></date-picker>
                                    -->
                                    <input
                                      id               = "meeting_date_incubator_info"
                                      class            = "form-control"
                                      type             = "text"
                                      v-model          = "project.meeting_date_incubator_info"
                                    >
                                    <!--<small class="form-text text-danger" v-if="$validator.meeting_date_incubator_info.required">Vous devez indiquer une date</small>-->
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Date dossier -->
                                <div class="form-group">
                                    <label for="incubator_application_deposit_date">Date dépôt dossier</label>
                                    <!--
                                    <date-picker
                                        :time.sync = "project.incubator_application_deposit_date"
                                        :option    = "datepickerOptions"
                                        :inputClass = "form-control"
                                    ></date-picker>
                                    -->
                                    <input
                                      id               = "incubator_application_deposit_date"
                                      class            = "form-control"
                                      type             = "text"
                                      v-model          = "project.incubator_application_deposit_date"
                                    >
                                    <!--<small class="form-text text-danger" v-if="$validator.incubator_application_deposit_date.required">Vous devez indiquer une date</small>-->
                                </div>
                            </div>
                    <div class="col-sm-6">
                        <!-- Referent -->
                        <div class="form-group">
                            <label for="name">Conseiller référent</label>
                          <select id="referentadviser_id" name="referentadviser_id" v-model="project.referentadviser_id" class="form-control">
                            <option value=""></option>
                            <option v-for="referentAdviser in firstintervenants" :value="referentAdviser.id">{{ referentAdviser.firstname }} {{ referentAdviser.lastname }}</option>
                          </select>
                            <!--<small class="form-text text-danger" v-if="$validator.referent_adviser.required">Vous devez indiquer un référent</small>-->
                        </div>
                    </div>
                    <div class="col-sm-6">
                                <!-- Lieu de suivi -->
                                <div class="form-group">
                                    <label for="name">Lieu de suivi</label>
		                    <select id="tracking_place" name="tracking_place" v-model="project.tracking_place" class="form-control">
		                        <option value=""></option>
		                        <option v-for="trackingPlace in trackingPlaces" :value="trackingPlace.id">{{ trackingPlace.name }}</option>
		                    </select>
                            <!--<small class="form-text text-danger" v-if="$validator.tracking_place.required">Vous devez indiquer un lieu de suivi</small>-->
                        </div>
                    </div>
                            <div class="col-sm-6">
                                <!-- Numéro adhésion -->
                                <div class="form-group">
                                <label for="">N° adhésion</label>
                                <input
                                    id               = "adhesion_num"
                                    class            = "form-control"
                                    type             = "text"
                                    v-model          = "project.adhesion_num"
                                >
                                </div>
                            </div>
                    <div class="col-sm-6">
                        <!-- Date de sortie -->
                        <div class="form-group">
                            <label for="exit_date">Date de sortie</label>
                            <!--
                            <date-picker
                                    :time.sync = "project.exit_date"
                                    :option    = "datepickerOptions"
                                    :inputClass = "form-control"
                            ></date-picker>
       	       	       	    -->
                            <input
                                      id               = "exit_date"
                                      class            = "form-control"
                                      type             = "text"
                                      v-model          = "project.exit_date"
                            >
                            <!--<small class="form-text text-danger" v-if="$validator.exit_date.required">Vous devez indiquer une date</small>-->
                        </div>
                    </div>
                </div>
            </fieldset>
            <br>
            <fieldset>
                <legend>Observations</legend>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <textarea rows="10" id="fs_observations" v-model="project.fs_observations" placeholder="" class="form-control"></textarea>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
        <div class="card-footer">
            <div class="actions">
                <a class="btn btn-link" v-link="{ path: '/project/list' }">Voir tous les parcours</a>
                <button class="btn btn-link" v-on:click.prevent="saveProject" v-if="$validator.valid">Sauvegarder le parcours</button>
            </div>
        </div>
      </div>
    </form>
  </validator>
</template>

<script>
// Options for datepicker
import { datepickerOptions } from 'src/options/date'

// Required for datepicker
import datePicker from 'vue-datepicker/vue-datepicker-1.vue'

import { project as currentProject, projectTypes, contact, users, firstintervenants, trackingPlaces } from '../../vuex/getters' // , referentAdvisers
import { edit as validationRules } from 'src/validations/project.js'
import { getProject, editProject } from 'src/vuex/actions/projectActions'
import { getProjectTypes } from 'src/vuex/actions/projectTypesActions'
import { getContact } from 'src/vuex/actions/contactActions'
import { getUsers } from 'src/vuex/actions/userActions'
// import { getReferentAdvisers } from 'src/vuex/actions/referentAdvisersActions'
import { getFirstintervenants } from 'src/vuex/actions/firstintervenantActions'
import { getTrackingPlaces } from 'src/vuex/actions/trackingPlacesActions'

// Notifications message
import toastr from 'toastr'
import moment from 'moment'

export default{
  vuex: {
    getters: { currentProject, projectUpdated: ({ projects }) => projects.projectUpdated, projectTypes, contact, users, trackingPlaces, firstintervenants }, // , referentAdvisers
    actions: { getProject, editProject, getProjectTypes, getContact, getUsers, getTrackingPlaces, getFirstintervenants } // , getReferentAdvisers
  },
  validators: {
  },
  data () {
    return {
      project: {},
      validationRules,
      showModal: false,
      datepickerOptions
    }
  },
  methods: {
    saveProject () {
      if (typeof (this.project.contact_date_fl) === 'undefined' || this.project.contact_date_fl === null || this.project.contact_date_fl === '' || this.project.contact_date_fl === 'undefined' || this.project.contact_date_fl === 'Invalid_date') {
        this.project.contact_date_fl = ''
      } else {
        this.project.contact_date_fl = moment(this.project.contact_date_fl, 'DD/MM/YYYY').format('DD-MM-YYYY')
      }
      if (typeof (this.project.incubator_application_deposit_date) === 'undefined' || this.project.incubator_application_deposit_date === null || this.project.incubator_application_deposit_date === '' || this.project.incubator_application_deposit_date === 'undefined' || this.project.incubator_application_deposit_date === 'Invalid_date') {
        this.project.incubator_application_deposit_date = ''
      } else {
        this.project.incubator_application_deposit_date = moment(this.project.incubator_application_deposit_date, 'DD/MM/YYYY').format('DD-MM-YYYY')
      }
      if (typeof (this.project.meeting_date_incubator_info) === 'undefined' || this.project.meeting_date_incubator_info === null || this.project.meeting_date_incubator_info === '' || this.project.meeting_date_incubator_info === 'undefined' || this.project.meeting_date_incubator_info === 'Invalid_date') {
        this.project.meeting_date_incubator_info = ''
      } else {
        this.project.meeting_date_incubator_info = moment(this.project.meeting_date_incubator_info, 'DD/MM/YYYY').format('DD-MM-YYYY')
      }
      if (typeof (this.project.first_meeting_date) === 'undefined' || this.project.first_meeting_date === null || this.project.first_meeting_date === '' || this.project.first_meeting_date === 'undefined' || this.project.first_meeting_date === 'Invalid_date') {
        this.project.first_meeting_date = ''
      } else {
        this.project.first_meeting_date = moment(this.project.first_meeting_date, 'DD/MM/YYYY').format('DD-MM-YYYY')
      }
      if (typeof (this.project.exit_date) === 'undefined' || this.project.exit_date === null || this.project.exit_date === '' || this.project.exit_date === 'undefined' || this.project.exit_date === 'Invalid date') {
        this.project.exit_date = ''
      } else {
        this.project.exit_date = moment(this.project.exit_date, 'DD/MM/YYYY').format('DD-MM-YYYY')
      }
      // console.log('saveParcours' + JSON.stringify(this.project))
      this.updateProjectName()
      this.editProject(this.currentProject, this.project)
    },
    showForm () {
      // console.log('changeParcours' + JSON.stringify(this.project))
    },
    updateProjectName () {
      console.log('updateProjectName ' + this.project.name + ' ' + this.project.project_type_id)
      if (this.project.project_type_id === '1' || this.project.project_type_id === 1) {
        this.project.name = 'ACA'
      } else if (this.project.project_type_id === '2' || this.project.project_type_id === 2) {
        this.project.name = 'REGION'
      } else if (this.project.project_type_id === '3' || this.project.project_type_id === 3) {
        this.project.name = 'COUVEUSE'
      } else if (this.project.project_type_id === '4' || this.project.project_type_id === 4) {
        this.project.name = 'COUVEUSE MOSSON'
      } else if (this.project.project_type_id === '5' || this.project.project_type_id === 5) {
        this.project.name = 'FORMATION CERTIFIANTE'
      } else if (this.project.project_type_id === '6' || this.project.project_type_id === 6) {
        this.project.name = 'FORMATION AUTRES'
      } else if (this.project.project_type_id === '7' || this.project.project_type_id === 7) {
        this.project.name = 'CLUB'
      } else if (this.project.project_type_id === '8' || this.project.project_type_id === 8) {
        this.project.name = 'CAE'
      } else if (this.project.project_type_id === '9' || this.project.project_type_id === 9) {
        this.project.name = 'PEPITE'
      } else if (this.project.project_type_id === '1000' || this.project.project_type_id === 1000) {
        this.project.name = 'AUTRE'
      }
    }
  },
  watch: {
    'projectUpdated' (value) {
      if (value === true) {
        toastr.success('Le parcours a bien été modifié')
        // this.$router.go('/project/list/')
        this.$router.go('/contact/parcours/' + this.project.contact_id)
      }
    }
  },
  components: { 'date-picker': datePicker },
  ready () {
    let vm = this
    this.getProjectTypes()
    this.getUsers()
    // this.getReferentAdvisers()
    this.getFirstintervenants()
    this.getTrackingPlaces()
    this.getProject(this.$route.params.projectId)
      .then(() => {
        vm.project = JSON.parse(JSON.stringify(vm.currentProject))
        if (vm.project.contact_date_fl === '0000-00-00') {
          vm.project.contact_date_fl = ''
        } else {
          vm.project.contact_date_fl = moment(vm.project.contact_date_fl).format('DD-MM-YYYY')
        }
        if (vm.project.contact_date_fl === 'Invalid date') {
          vm.project.contact_date_fl = ''
        }
        if (vm.project.meeting_date_incubator_info === '0000-00-00') {
          vm.project.meeting_date_incubator_info = ''
        } else {
          vm.project.meeting_date_incubator_info = moment(vm.project.meeting_date_incubator_info).format('DD-MM-YYYY')
        }
        if (vm.project.meeting_date_incubator_info === 'Invalid date') {
          vm.project.meeting_date_incubator_info = ''
        }
        if (vm.project.incubator_application_deposit_date === '0000-00-00') {
          vm.project.incubator_application_deposit_date = ''
        } else {
          vm.project.incubator_application_deposit_date = moment(vm.project.incubator_application_deposit_date).format('DD-MM-YYYY')
        }
        if (vm.project.incubator_application_deposit_date === 'Invalid date') {
          vm.project.incubator_application_deposit_date = ''
        }
        if (vm.project.first_meeting_date === '0000-00-00') {
          vm.project.first_meeting_date = ''
        } else {
          vm.project.first_meeting_date = moment(vm.project.first_meeting_date).format('DD-MM-YYYY')
        }
        if (vm.project.first_meeting_date === 'Invalid date') {
          vm.project.first_meeting_date = ''
        }
        if (vm.project.exit_date === '0000-00-00') {
          vm.project.exit_date = ''
        } else {
          vm.project.exit_date = moment(vm.project.exit_date).format('DD-MM-YYYY')
        }
        if (vm.project.exit_date === 'Invalid date') {
          vm.project.exit_date = ''
        }

        console.log('project_type_id : ' + vm.currentProject.project_type_id + ' ' + vm.project.project_type_id)
        console.log('contact_id : ' + vm.currentProject.contact_id + ' ' + vm.project.contact_id)
        vm.getContact(vm.project.contact_id)
      })
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// ProjectEdit.vue?3f4c295a